import React, {ReactNode, useState, useRef} from 'react';
import {getLinkPath, scrollToTop} from 'app/utils';
import {Link} from 'react-router-dom';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import I18n from 'app/i18n';
import coinDeposit from 'images/bonuses/bonuses-card/coin-deposit.png';
import {useClickOutside} from 'app/utils/useClickOutside';

const DepositBonusesCard = (): ReactNode => {
    const [isInfoActive, setIsInfoActive] = useState(false);
    const cardRef = useRef<HTMLDivElement>(null);

    useClickOutside(cardRef, () => setIsInfoActive(false), isInfoActive);

    const toggleInfoActive = () => setIsInfoActive(prev => !prev);

    return <div className="bonuses-card bonuses-card--deposit" ref={cardRef}>
        {isInfoActive
            ? <div className="bonuses-card-wrapper-info">
                <p className="bonuses-card-wrapper-info__title">
                    {I18n.t('bonuses_page.first_deposit')}
                </p>
                <div className="bonuses-card-wrapper-info__text" dangerouslySetInnerHTML={{__html: I18n.t('bonuses_page.deposit_bonus_desc')}}/>
            </div>
            : <div className="bonuses-card-wrapper">
                <div className="bonuses-card__img">
                    <img src={coinDeposit} alt="deposit x2" />
                </div>
                <p className="bonuses-card__amount">{I18n.t('user.deposit')} x2</p>
                <p className="bonuses-card-time bonuses-card-time__text">{I18n.t('bonuses_page.up_to')}</p>
                <Link
                    to={getLinkPath('/deposits')}
                    onClick={scrollToTop}
                    className="bonuses-card__btn bonuses-card__btn--activation">{I18n.t('user.deposit')}</Link>
            </div>}
        {isInfoActive
            ? <div className="bonuses-card__close" onClick={toggleInfoActive}>
                <SpriteIcon name="#svg-close" size={{height: 12, width: 12}}/>
            </div>
            : <div className="bonuses-card__info" onClick={toggleInfoActive}>
                <SpriteIcon name="#svg-question" size={{height: 16, width: 16}}/>
            </div>}
    </div>;
};

export default DepositBonusesCard;
